import { Component, OnInit, Input } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant liste de documentation
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-liste-documentation',
  templateUrl: './liste-documentation.component.html',
  styleUrls: ['./liste-documentation.component.scss']
})
export class ListeDocumentationComponent extends BaseComponent implements OnInit {

    @Input() documents: any[];

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }
}
